import { RouteObject } from 'react-router';

const paymentErrorRoutes: RouteObject[] = [
  {
    path: 'paymentError',
    lazy: () => import('./page/payment-error-page.tsx'),
  },
];

export default paymentErrorRoutes;
